import React, { useEffect, useState } from 'react';
import * as S from './styles';
import { useOrder } from '../../hooks';
import {
  Topbar,
  Navbar,
  DashboardFooter,
  Breadcrumb,
  OrderCardDanfe,
  Pagination,
  DynamicFilter,
} from '../../components';
import LoadingAnimated from '../../assets/loading-animated.svg';
import {
  IDynamicFilterData,
  IDynamicFilterSelectOptions,
  IOrderProps,
} from '../../interfaces';
import { usePagination } from '../../hooks/usePagination';
import { masks } from '../../constants/masks';
import { formatCNPJ } from '../../utils/functions';

export const SendDanfeXML: React.FC = () => {
  const {
    errors,
    isLoading,
    loadedItems,
    getNewPaginatedOrders,
    qtdeRegistros,
  } = useOrder();

  const today = new Date();

  // 45 dias retroativos
  const startDate = new Date();
  startDate.setDate(today.getDate() - 45);

  // 12 meses retroativos
  const blockDate = new Date();
  blockDate.setMonth(today.getMonth() - 12);

  const [dateStart, setDateStart] = useState<string>(
    startDate.toISOString().split('T')[0],
  );
  const [dateEnd, setDateEnd] = useState<string>(
    today.toISOString().split('T')[0],
  );

  const { currentPage, pageSize, handlePageChange, resetPagination } =
    usePagination({
      totalItems: qtdeRegistros || 0,
      onPageChange: (currentPage, pageSize) => {
        getNewPaginatedOrders({
          ...filters,
          currentPage,
          pageSize,
        });
      },
    });

  const searchOrders = async (filterData: IDynamicFilterData) => {
    if (filterData.type === 'cnpj') {
      setFilters({ ...filterData, term: formatCNPJ(filterData.term) });
    }

    resetPagination();

    await getNewPaginatedOrders({
      ...filterData,
      isNewSearch: true,
      currentPage: 1,
      pageSize: 20,
    });
  };

  const filterSelectOptions: IDynamicFilterSelectOptions[] = [
    { value: 'clienteNome', description: 'Nome do Cliente' },
    { value: 'cnpj', description: 'CNPJ' },
    {
      value: 'numNota',
      description: 'Número da Nota Fiscal',
    },
    {
      value: 'numPedAllied',
      description: 'Número do Pedido Allied',
    },
    {
      value: 'numPedEcom',
      description: 'Número do Pedido E-Commerce',
    },
  ];

  const [filters, setFilters] = useState<IDynamicFilterData>({
    type: filterSelectOptions[0].value,
    term: '',
    dateStart: dateStart,
    dateEnd: dateEnd,
  });

  useEffect(() => {
    getNewPaginatedOrders({
      ...filters,
      currentPage: 1,
      pageSize: 20,
    });
  }, []);

  return (
    <S.Container>
      <Topbar />
      <Navbar />
      <S.Content>
        <Breadcrumb paths={paths} />
        <S.Title>Envio de DANFE e XML</S.Title>
        <DynamicFilter
          calendar
          filterSelectOptions={filterSelectOptions}
          filters={filters}
          setFilters={setFilters}
          isLoading={isLoading}
          searchFilters={searchOrders}
        />
        <S.Orders>
          <S.TitleSmall>Pedidos</S.TitleSmall>
          <S.Items>
            {!isLoading &&
              loadedItems?.map(
                (element: IOrderProps, index: React.Key | null | undefined) => (
                  <OrderCardDanfe
                    key={index}
                    order={element}
                    term={filters.term}
                    type={filters.type}
                  />
                ),
              )}
          </S.Items>
          <S.Items>
            {isLoading && <S.LoadingAnimated src={LoadingAnimated} />}
          </S.Items>
          <S.Items>{!isLoading && errors && <p>{errors}</p>}</S.Items>
        </S.Orders>

        {!isLoading && !errors?.length && (
          <Pagination
            currentPage={currentPage}
            paginationSize={pageSize}
            onPageChange={handlePageChange}
            totalItems={qtdeRegistros}
          />
        )}
      </S.Content>
      <DashboardFooter />
    </S.Container>
  );
};

const paths = [
  {
    title: 'Meu Painel',
    link: '/painel',
  },
  {
    title: 'Envio de DANFE e XML',
    link: '/envio-danfe-xml',
  },
];
